export default {
    activityLog: 'Activity Log',
    sortByLasted: 'Sort by Lasted Activity',
    sortByEarliest: 'Sort by Earliest Activity'
}
